import { useFramework } from '@/framework';
import { TEXT_EDIT_EVENTS } from '../constants';

export const useMouseEvent = () => {
    const framework = useFramework();

    const handleMouseDown = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();

        framework.events.emit(TEXT_EDIT_EVENTS.MOUSE_DOWN, event.nativeEvent);

        // TODO: 看看后续是否可以在此处处理火狐浏览器光标的兼容性问题
        // BUG：https://jira.meitu.com/browse/MTXXPRO-49662
    };

    // 阻止冒泡，编辑时禁用右键菜单
    const handleContextMenu = (event: React.MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
    };

    return {
        handleMouseDown,
        handleContextMenu,
    };
};
